import { defineComponent as _defineComponent } from 'vue'
import { watchEffect, ref, watch, defineProps, defineEmits } from "../../../../adapter-vue";
import { TUITranslateService } from "@tencentcloud/chat-uikit-engine";

export default /*#__PURE__*/_defineComponent({
  __name: 'message-revoked',
  props: {
  isEdit: {
    type: Boolean,
    default: () => false,
  },
  messageItem: {
    type: Object,
    default: () => ({}),
  },
},
  emits: ["messageEdit"],
  setup(__props, { emit: emits }) {

const props = __props



const message = ref();
const isEditMsg = ref(false);

watchEffect(() => {
  message.value = props.messageItem;
  isEditMsg.value = props.isEdit;
});
const messageEdit = () => {
  emits("messageEdit");
};

return { __sfc: true,props, message, isEditMsg, emits, messageEdit, TUITranslateService }
}

})